
  <template>
    <div class="gift-selection">
    <div class="banner">
    <img :src="bannerUrl" alt="Banner" class="banner" />
    
     </div>

      <div class="header">
        <span class="back-btn material-symbols-outlined" @click="goBack">arrow_back_ios</span>
        <h2 class="title">Gift Selection</h2>
        <div class="progress-dots">
          <span></span>
          <span></span>
          <span class="active"></span>
        </div>
      </div>

      <div class="form-card" v-if="gifts.length > 0">
        <label class="section-label">
          Kindly select one from the gifts listed here <span class="required">*</span>
        </label>
        <div class="gift-grid">
          <label v-for="(g, index) in gifts" :key="selectedProductData.tmp_SKU_code + '-' + g.tmg_id + '-' + index" class="gift-card">
            <div class="gift-content">
              <img
                :src="'https://loyalty.elevatozrewards.com/wp-content/uploads/2025/09/' + g.tmg_gift_image"
                :alt="g.tmg_description"
                class="gift-image"
              />
            </div>
            <div class="radio_button">
                <input type="radio" class="gift-radio" name="gift-selection" v-model="gift1" :value="g.tmg_id"/>
                <span class="gift-name">{{ g.tmg_description }}</span>
            </div>
          </label>
        </div>
      </div>
      <p v-else>No gifts available for this product.</p>

      <button type="button" class="submit-btn" @click="submitForm">Submit</button>
      <div class="footer">
        Powered by Elevatoz PVT LTD
      </div>
    </div>
  </template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

const API_BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
  name: "GiftSelection",
  props: {
    product: { type: [String, Object], required: true },
    manualSKU: { type: String, default: "" },
    quantity: { type: [String, Number], required: true },
    customer: { type: Object, required: true },
    initialGift: { type: [String, Number], default: "" },
  },

  data() {
    return {
      bannerUrl: process.env.VUE_APP_BANNER_URL,
      gifts: [],
      gift1: this.initialGift ? String(this.initialGift) : "",
      selectedProductData: null,
      loading: true,
    };
  },


  async mounted() {
    if (!this.product) {
      console.warn("No SKU or Product provided to GiftSelection");
      this.loading = false;
      return;
    }

    // 1. Mattress code: manual code for "Other", otherwise the selected SKU
    const isOther = this.customer?.productSKU === "Other" || this.product === "Other";
    const productCode = isOther
      ? this.customer?.manualMatressCode || this.manualSKU
      : typeof this.product === "string"
      ? this.product
      : this.product?.tmp_SKU_code;

    const modelName =
      typeof this.product === "object"
        ? this.product.name
        : this.customer?.productName || "";

    try {
      // 2. The server returns this product's gifts, slab 1 first, highest price first
      const res = await axios.post(`${API_BASE_URL}vt/centuryCenflex/getGift`, {
        product_code: productCode,
        model_name: modelName,
      });

      if (res.data?.code === 0) {
        const data = res.data.data || {};

        // set first: the template reads selectedProductData in the :key
        this.selectedProductData = {
          tmp_SKU_code: productCode || "other",
          tmp_model_name: data.model_name || modelName,
          tmp_collection_id: data.collection_id,
        };
        this.gifts = data.gifts || [];
      } else {
        console.warn("getgifts:", res.data?.errors);
        this.gifts = [];
      }
    } catch (err) {
      console.error("Gift fetch failed:", err.response?.data || err);
      this.gifts = [];
    } finally {
      // keep selectedProductData non-null so the template key never fails
      if (!this.selectedProductData) {
        this.selectedProductData = {
          tmp_SKU_code: productCode || "other",
          tmp_model_name: modelName,
        };
      }
      this.loading = false;
    }
  },

  methods: {
    goBack() {
      this.$emit("go-back");
    },

    submitForm() {
      if (!this.gift1) {
        Swal.fire({
          icon: "warning",
          title: "Missing Selection",
          text: "Please select your gift!",
          confirmButtonColor: "#f39c12",
        });
        return;
      }

      const selectedGift = this.gifts.find(
        (g) => String(g.tmg_id) === String(this.gift1)
      );
      if (!selectedGift) {
        Swal.fire({
          icon: "error",
          title: "Gift not found",
          text: "Please select your gift again.",
          confirmButtonColor: "#d33",
        });
        return;
      }

      const isOther = this.customer.productSKU === "Other";

      this.$emit("validated", {
        ...this.customer,
        productName: this.selectedProductData?.tmp_model_name || this.customer.productName,
        mattressCode: isOther ? this.customer.manualMatressCode : this.customer.productSKU,
        selectedGift,
        isOtherSelected: isOther ? 1 : 0,
      });
    },
  },
};
</script>



  <style scoped>
  .gift-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .gift-card {
    border: 2px solid #ddd;
    border-radius: 10px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: border-color 0.3s, box-shadow 0.3s;
    text-decoration: none;
    color: inherit;
  }
  .gift-radio:checked + .gift-content {
    border: 4px solid #FCC200;
    box-shadow: 0 0 8px rgba(207, 207, 207, 0.5);
    border-radius: 6px;
  }
  
  .gift-radio[data-v-00c96f1c] {
    margin-right: 16px;
  }
  .gift-content {
    text-align: center;
    transition: border 0.3s, box-shadow 0.3s;
    padding: 5px;
  }
  .gift-image {
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin-bottom: 10px;
  }
  .gift-name {
    font-weight: bold;
    font-size: 14px;
  }
  .title {
    font-weight: 500;
    font-size: 1.2rem;
    flex: 1;
    text-align: left;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    position: relative;
  }
  .banner img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 15px;
  }
  .back-btn {
    cursor: pointer;
    font-size: 20px;
  }
  .progress-dots {
    display: flex;
    gap: 5px;
  }
  .progress-dots span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    display: inline-block;
  }
  .progress-dots span.active {
    background: #006488;
  }
  .form-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .required { color: red; }
  .submit-btn {
    display: block;
    margin: 20px auto 0;
    width: 70%;
    padding: 12px;
    background: #006488;
    color: #fff;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    text-align: center;
  }
  .otp-footer { display: flex; justify-content: center; margin-top: 20px; }
  .footer {
  margin-top: auto; 
  font-size: 0.6rem;
  color: #888;
  text-align: center;
}
  .submit-btn:hover { background: #005270; }
  </style>

